import React, {FormEvent} from "react";
import {useTranslation} from "react-i18next";
import styles from "./HeaderSearch.module.scss";
import {TopSuggestionType} from "./HeaderSearch";

type TopSuggestionItemPropsType = {item: TopSuggestionType; onClick: (event: FormEvent) => void};

// top brand or product category or (string) configurator in search suggestion box
// our api returns a 360x360 image for imageUrlFull2x and a 720x720 image for imageUrlHalf2x, that's why imageUrlHalf2x is used for retina displays in this case
const TopSuggestionItem: React.FC<TopSuggestionItemPropsType> = ({item, onClick}) => {
  const {t} = useTranslation();
  const topResultTitle = item.name;
  let topResultHeadline = t("product.product_type");
  let showIcon = true;
  let iconName = "categories";

  switch (item.type) {
    case "brand":
      showIcon = false;
      topResultHeadline = t("product.brand");
      break;
    case "configurator":
      iconName = "configurate";
      topResultHeadline = t("general.configurator__other");
      break;
  }

  return (
    <>
      <div className={styles.suggestHead}>{topResultHeadline}</div>
      <a
        href={item.productUrl}
        onClick={onClick}
        title={t("general.open--title", {title: topResultTitle})}
        className={`${styles.suggestItem} ${styles.suggestItemTop}`}
      >
        <div className={`${styles.suggestItemImage} ${styles.suggestItemTopImage}`}>
          {showIcon ? (
            <i className={`icon icon-${iconName} icon-size--24`} />
          ) : (
            <img
              src={item.imageUrlFull2x}
              srcSet={item.imageUrlHalf2x ? `${item.imageUrlFull2x} 1x, ${item.imageUrlHalf2x} 2x` : undefined}
              alt={topResultTitle}
              loading="lazy"
              width="36"
              height="auto"
            />
          )}
        </div>
        <div className={styles.suggestItemContent}>
          <span className={styles.suggestItemContentTitle}>{topResultTitle}</span>
        </div>
        <div className={styles.suggestItemIcon}>
          <i className="icon icon-right icon-size--22" />
        </div>
      </a>
    </>
  );
};

export default TopSuggestionItem;
